export default __webpack_public_path__ + "static/media/longchamp23.7af7bcf1.jpg";